import { Component } from 'react'
import FieldManagementServices from '../../services/axiosServices/apiServices/FieldManagementServices';
import SwalServices from "../../services/swalServices/SwalServices";
import EditChapterManagerEmails from '../../components/fieldManagement/EditChapterManagerEmails';
import { CommonValidationMessages } from '../../utils/Messages';
import { isValidForm } from '../../utils/validation/CommonValidator';

export default class ChapterManagerEmails extends Component {
    constructor(props) {
        super(props);
        this.fieldManagementServices = new FieldManagementServices();
        this.swalServices = new SwalServices();
        this.state = {
            isLoading: false,
            isSaveLoading: false,
            redirect: null,
            totalResultes: 0,
            totalCount: 0,
            addEditChapter: false,
            addNewChapter: false,
            selectChapterId: 0,
            chapterManagerEmail: [],
            length: 0,
            chapterDetails: {
                chapterManagerEmail: "",
                ccEmails: "",
                chapterManagerEmailId: 0
            },
            validationRule: {
                chapterManagerEmail: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}", "Chapter Email"
                        )
                    },
                    {
                        type: "multiEmail",
                        message: "Please enter valid comma-separated emails"
                    }
                ],
                ccEmails: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}", "CC Email"
                        )
                    },
                    {
                        type: "multiEmail",
                        message: "Please enter valid comma-separated emails"
                    }
                ]
            },
            validState: {
                isValid: true,
                error: {}
            },
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "",
                orderFlag: 0,
                searchText: "",
            },
            tagList: [],
            createdBy: 0,
        };
    }

    isValidateAllFields = () => {
        const newValidState = isValidForm(
            this.state.chapterDetails,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    resetValidation() {
        this.setState({ validState: { isValid: true, error: {} } });
    }

    setPagination = (newPagination) => {
        this.setState({ pagination: newPagination });
    };

    getchapterManagerList = (pagination = this.state.pagination) => {
        this.setState({ isLoading: true });
        this.fieldManagementServices.getAllChapterManagerEmailList(pagination).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent != null) {
                this.setState({ length: response.responseItem.responseContent.length + 1, chapterManagerEmail: response.responseItem.responseContent, totalResultes: response.responseItem.responseContent.length });
            } else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
            this.swalServices.Error("Something went wrong. Please try again.");
        });
    };

    cancelAddEditChapter() {
        this.setState({
            addEditChapter: false
        })
    }

    handleChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        let detail = this.state.chapterDetails;
        detail[name] = value;
        this.setState({ chapterDetails: { ...detail } });
    }


    updateChapterManagerEmail = () => {
        const isValid = this.isValidateAllFields();
        if (!isValid || this.state.isSaveLoading) {
            return;
        }
        const request = {
            chapterManagerEmailId: this.state.chapterDetails.chapterManagerEmailId,
            chapterManagerEmail: this.state.chapterDetails.chapterManagerEmail,
            ccEmails: this.state.chapterDetails.ccEmails
        };
        this.setState({ isSaveLoading: true });
        this.fieldManagementServices.updateChapterManagerEmail(request)
            .then((response) => {
                if (response.statusCode === 200) {
                    this.swalServices.Success("Chapter Manager Email updated successfully");
                    this.setState({ addEditChapter: false }, () => {
                        this.getchapterManagerList();
                    });
                } else {
                    this.swalServices.Error(response.message);
                }
                this.setState({ isSaveLoading: false });
            }).catch(() => {
                this.setState({ isSaveLoading: false });
                this.swalServices.Error("Something went wrong. Please try again.");
            });
    };

    componentDidMount() {
        this.getchapterManagerList();
    }

    startEditing = (chapter) => {
        this.setState({
            addEditChapter: true,
            selectChapterId: chapter.chapterManagerEmailId,
            chapterDetails: {
                chapterManagerEmailId: chapter.chapterManagerEmailId,
                chapterManagerEmail: chapter.chapterManagerEmail,
                ccEmails: chapter.ccEmails
            }
        });
    };

    render() {
        return (
            <div className="main-body-section">
                <div className="relative">
                    <div>
                        <div className=" mt-6">

                            <EditChapterManagerEmails
                                chapterManagerEmail={this.state.chapterManagerEmail}
                                addEditChapter={this.state.addEditChapter}
                                addNewChapter={this.state.addNewChapter}
                                selectChapterId={this.state.selectChapterId}
                                handleChange={this.handleChange.bind(this)}
                                updateChapterManagerEmail={this.updateChapterManagerEmail.bind(this)}
                                cancelAddEditChapter={this.cancelAddEditChapter.bind(this)}
                                length={this.state.length}
                                startEditing={this.startEditing.bind(this)}
                                chapterDetails={this.state.chapterDetails}
                                validState={this.state.validState}
                                validationRule={this.state.validationRule}
                                isSaveLoading={this.state.isSaveLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
